<template>
  <v-app id="emoc">
    <router-view name="navbar"></router-view>
    <v-main>
      <!--derhammer added this :key attrib to force rerender when navigating "back"
      after selecting a community on the community dashboard page.... prior to this
      it was not reloading the component and keeping the ID when the path changed
      if you have issue with this, let's talk about other solutions-->
      <router-view :key="$route.fullPath" />
      <!-- <RouterView /> -->
    </v-main>

    <v-footer app>
      <v-spacer></v-spacer>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style></style>
